<template>
  <div>
    <v-img :contain="contain" :src="thumbnailImage" :width="width" :height="height">
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-1"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
  </div>
</template>

<script>
import FileService from '@/services/file/FileService'

export default {
  data: () => ({
    isLoading: true,
    thumbnailData: null,
    unknown_image: require('../../assets/unknown_thumbnail.png')
  }),
  props: {
    fileId: Number,
    width: {
      type: Number,
      default: 130
    },
    height: {
      type: Number,
      default: 75
    },
    contain: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    thumbnailImage () {
      if (this.thumbnailData != null) {
        return `data:image/jpg;base64,${this.thumbnailData}`
      } else {
        return this.unknown_image
      }
    }
  },
  mounted () {
    if (this.fileId === -1) {
      return
    }

    FileService.getFileData(this.fileId).then(file => {
      this.thumbnailData = file.data
      this.isLoading = false
    })
  },
  watch: {
    fileId: function () {
      this.thumbnailData = null

      if (this.fileId === -1) {
        return
      }

      this.isLoading = true

      FileService.getFileData(this.fileId).then(file => {
        this.thumbnailData = file.data
        this.isLoading = false
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/Thumbnail.vue